$(function() {
    "use strict";

    var disable = function(element) {
        if (!$(element).hasClass("custom-checkbox_disabled")) {
            $(element).parent(".custom-checkbox").addClass("custom-checkbox_disabled");
        }
    };

    var undisable = function(element) {
        $(element).parent(".custom-checkbox").removeClass("custom-checkbox_disabled");
    };

    var toggleDisabled = function(element) {
        if ($(element).is(":disabled")) {
            disable(element);
        }
        else {
            undisable(element);
        }
    };

    $(document).on("click.custom-checkbox", ".custom-checkbox_disabled", function(event) {
        event.preventDefault();
    });

    $(".custom-checkbox > input:disabled").each(function() {
        disable($(this));
    });

    var check = function(element) {
        if (!$(element).hasClass("custom-checkbox_checked")) {
            $(element).parent(".custom-checkbox").addClass("custom-checkbox_checked");
        }
    };

    var uncheck = function(element) {
        $(element).parent(".custom-checkbox").removeClass("custom-checkbox_checked");
    };

    var toggleChecked = function(element) {
        if ($(element).is(":checked")) {
            check(element);
        }
        else {
            uncheck(element);
        };
    };

    $(".custom-checkbox > input:checked").each(function() {
        toggleChecked($(this));
    });

    $(document).on("change.custom-checkbox", ".custom-checkbox > input", function(event) {
        toggleChecked($(this));
    });
});